<section class="about-section position-relative overflow-hidden bg-white">

  <!-- Single Background Image Layer -->
  <img
    [src]="aboutSection.backgroundImage"
    class="about-bg-image position-absolute top-0 start-0 w-100 h-100 object-fit-cover pointer-events-none"
    alt="background"
  />

  <div class="container position-relative about-content-layer">
    <div class="row align-items-center">

      <!-- Left Content Column -->
      <div class="col-lg-6 col-md-12 text-center text-lg-start mb-5 mb-lg-0">

        <h1 class="fw-bold mb-4 mission-main-title">
          ABOUT THE MISSION
        </h1>

        <h2 class="fw-semibold mb-4 mission-sub-title">
          A sovereign, inclusive, future-ready AI ecosystem.
        </h2>

        <p class="mb-4 text-muted mission-description">
          In March 2024, the Government of India approved the IndiaAI Mission to
          develop a sovereign AI ecosystem across seven pillars. The Mission
          aims to establish India's own AI infrastructure and reduce
          dependence on external systems.
        </p>

        <div class="d-flex flex-wrap gap-2 justify-content-center justify-content-lg-start pt-2 mission-badge-container">
          <span class="benefit-badge">Compute</span>
          <span class="benefit-badge">Datasets</span>
          <span class="benefit-badge">Foundation Models</span>
          <span class="benefit-badge">Future Skills</span>
          <span class="benefit-badge">Application Dev</span>
          <span class="benefit-badge">Startup Financing</span>
          <span class="benefit-badge">Safe & Trusted AI</span>
        </div>

      </div>

      <!-- Right Visual Column (Using the exact layout configuration from the wireframe screenshot) -->
      <!-- <div class="col-lg-6 col-md-12 position-relative d-flex justify-content-center align-items-center visual-grid-container">

        <div class="position-absolute rounded-circle dot-orange"></div>
        <div class="position-absolute rounded-circle dot-darkred"></div>

        <div class="position-relative w-100 h-100 d-flex justify-content-center align-items-center">
        </div>

      </div> -->

    </div>
  </div>
</section>